import { css } from '@emotion/css';

export const setWidth = (width: number) => css`
  width: ${width}px;
`;
